const footer = () => {
  if ($(window).width() < 990) {
    $("footer .titolo-widget-sidebar").click(function () {
      if ($(this).find(".toggler").length) $(this).nextAll("div").slideToggle();
    });
    $("footer .toggler").each(function () {
      $(this).parent(".titolo-widget-sidebar").nextAll().hide();
    });
  }

  const contattiSection = document.querySelector('.contatti__section');
  const footerEl = document.querySelector('#footer');

  if (!contattiSection || !footerEl) return;

  const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
  const buttonHeightPx = 5 * rem;
  const gapPx = 5 * rem;

  const updateLockPosition = () => {
    const footerTopInDoc = footerEl.getBoundingClientRect().top + window.scrollY;
    contattiSection.style.top = `${footerTopInDoc - gapPx - buttonHeightPx}px`;
  };

  ScrollTrigger.create({
    trigger: footerEl,
    start: 'top bottom',
    onEnter: () => {
      contattiSection.classList.add('locked');
      updateLockPosition();
    },
    onLeaveBack: () => {
      contattiSection.classList.remove('locked');
      contattiSection.style.top = '';
    },
  });

  ScrollTrigger.addEventListener('refresh', () => {
    if (contattiSection.classList.contains('locked')) {
      updateLockPosition();
    }
  });
};

export default footer;
